import { z } from 'zod';

const jwtLike = /ey[A-Za-z0-9_-]*\.ey[A-Za-z0-9_-]*\.[A-Za-z0-9_-]*/;

export const JwtTokenSchema = z.string().regex(jwtLike).brand<'JwtToken'>();
export type JwtToken = z.infer<typeof JwtTokenSchema>;

export const CognitoTokenEndpointSchema = z.object({
  access_token: JwtTokenSchema,
  expires_in: z.number(),
  token_type: z.string(),
});

/**
 * Response of the OAuth2 `refresh_token` grant. Unlike the client-credentials response
 * ({@link CognitoTokenEndpointSchema}) it also carries an `id_token`. Both `id_token` and
 * `refresh_token` are optional: Cognito may omit the id token depending on app-client config,
 * and only returns a new refresh token when rotation is enabled.
 */
export const CognitoRefreshResponseSchema = z.object({
  access_token: JwtTokenSchema,
  id_token: JwtTokenSchema.optional(),
  refresh_token: z.string().optional(),
  expires_in: z.number(),
  token_type: z.string(),
});
